import axios from "axios";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import tw from "tailwind-styled-components";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import NotFoundModel from "../../Components/NotFoundModel";
import {
  Bg,
  BoxContainer,
  Button,
  Underline,
} from "../../Components/Styles/PageStyles";
import Config from "../../Config";
import Images from "../../Images";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { MdAdd } from "react-icons/md";
import AddFoodItem from "../../Components/FoodItem/AddFoodItem";
import EditFoodItem from "../../Components/FoodItem/EditFoodItem";
import Table from "../../Components/FoodItem/Table";
import FoodItemDeleteModal from "../../Components/FoodItem/DeleteFoodItem";

export const FoodItem = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState();
  const [addFoodItems, setAddFoodItems] = useState(false);
  const [editData, setEditData] = useState(false);
  const [deleteFoodItem, setDeleteFoodItem] = useState(false);
  const [apiData, setApiData] = useState();
  const location = useLocation();

  const fetchData = async () => {
    const body = new FormData();
    body.append("id", location.state.id);
    return await axios.post(`${Config.apiUrl}/getinventorytype`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onDataSuccess = (res) => {
    if (res.data.status == "NOK" || res.data.data == false) error = true;
    setApiData(res.data);
  };

  const onDataError = (data) => {};
  useEffect(() => {
    const handler = setTimeout(() => {
      DataMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, []);

  const {
    isLoading: isDataLoading,
    mutate: DataMutate,
    error,
    data,
  } = useMutation(fetchData, {
    onSuccess: onDataSuccess,
    onError: onDataError,
  });

//----------Add Food Items------------------------------------------------------------------------  

  const addData = async (values) => {
    const body = new FormData();
    body.append("categoryId", location.state.id);

    Object.keys(values).forEach((i) => body.append(i, values[i]));

    return await axios.post(`${Config.apiUrl}/addinventorytype`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onAddSuccess = (data) => {
    toast.success(data?.data?.msg || "Success");
    // DataMutate();
    setApiData(data?.data);
    setAddFoodItems(false);
  };

  const onAddError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    // DataMutate();
    setAddFoodItems(false);
  };

  const { isLoading: addFoodItemLoading, mutate: addFoodItemMutate } =
    useMutation(addData, {
      onSuccess: onAddSuccess,
      onError: onAddError,
    });

//-------------------Edit Food Items--------------------------------------------
  const editDataPost = async (values) => {
    const body = new FormData();

    Object.keys(values).forEach((i) => body.append(i, values[i]));

    return await axios.post(`${Config.apiUrl}/editinventorytype`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onEditSuccess = (data) => {
    toast.success(data?.data?.msg || "Success");
    setApiData(data?.data);
    // DataMutate();
    setEditData(false);
  };

  const onEditError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    // DataMutate();
    setEditData(false);
  };

  const { isLoading: editIsLoading, mutate: editMutate } = useMutation(
    editDataPost,
    {
      onSuccess: onEditSuccess,
      onError: onEditError,
    }
  );

//--------------Delete Food Item----------------------------------------------
const onDeleteFoodItem = async (item) => {
  const body = new FormData();

  body.append("id", item.id); 

  return await axios.post(`${Config.apiUrl}/deletefooditem`, body, {
    headers: {
      authorization: "Bearer " + user.token,
      "Content-Type":
        "application/x-www-form-urlencoded; charset=UTF-8",
    },
  });
};

const onDeleteFoodItemSuccess = (data) => {
  if (data?.data?.status === "OK") {
    toast.success(
      data?.data?.msg || "Food item deleted successfully"
    );

    setSelectedData(undefined);
    setDeleteFoodItem(false);
    DataMutate();
  } else {
    toast.error(
      data?.data?.msg || "Unable to delete food item"
    );
  }
};

const onDeleteFoodItemError = (error) => {
  toast.error(
    error?.response?.data?.msg ||
      "An error occurred while deleting food item"
  );
    };

const {
  isLoading: deleteFoodItemLoading,
  mutate: deleteFoodItemMutate,
} = useMutation(onDeleteFoodItem, {
  onSuccess: onDeleteFoodItemSuccess,
  onError: onDeleteFoodItemError,
});


  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {"Inventory Types "}
                {"\u00A0"}
                <span className="text-primary-color">
                  ( {location?.state?.category} )
                </span>
              </Title>
              <Underline />
            </div>
            <UploadWrapper>
              <Button type="button" onClick={() => setAddFoodItems(true)}>
                <MdAdd className="text-white w-5 h-5" />{" "}
                <p className="text-sm">{"Add Type"}</p>
              </Button>
            </UploadWrapper>
          </div>

          {addFoodItems && (
            <AddFoodItem
              setAddFoodItems={setAddFoodItems}
              addFoodItemLoading={addFoodItemLoading}
              addFoodItemMutate={addFoodItemMutate}
            />
          )}
 
          {editData && (
            <EditFoodItem
              setEditData={setEditData}
              selectedData={selectedData}
              loading={editIsLoading}
              mutate={editMutate}
            />
          )}

          {deleteFoodItem && (
            <FoodItemDeleteModal
                setDeleteFoodItem={setDeleteFoodItem}
                deleteItemMutate={deleteFoodItemMutate}
                deleteItemLoading={deleteFoodItemLoading}
                selectedData={selectedData}
            />
            )}

          {!error && !isDataLoading && data && (
            <TableWrapper>
              <Table
                ApiData={apiData?.data}
                setSelectedData={setSelectedData}
                userType={user.userType}
                setEditData={setEditData}
                setDeleteFoodItem={setDeleteFoodItem}
              />
              {(error || apiData?.msg == "No data found") && !isDataLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {isDataLoading && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};
const Title = tw.h1`text-xl w-full text-gray-800 whitespace-nowrap font-medium flex justift-center`;
const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const UploadWrapper = tw.div`w-full flex justify-end space-x-4 items-center `;
